import React, { useEffect, useState } from "react";

import ModalDefault from "components/ModalDefault";
import { useDispatch, useSelector } from "react-redux";

import {
  Container,
  HeaderContainer,
  Content,
  HeaderTitle,
  IconsContainer,
} from "./styles";
import ArrowDown from "../../assets/svg/arrow-down.svg";
import ArrowUp from "../../assets/svg/arrow-up.svg";
import close from "../../assets/svg/close.svg";
import UploadFileItem from "../../components/UploadFileItem";
import { useToast } from "../../hooks/toast";
import { cleanUpload } from "../../store/modules/attachment/actions";
import { IUpload } from "../../store/modules/attachment/interface";

const ContainerGlobalDownload: React.FC = () => {
  const [show, setShow] = useState(false);
  const [showContainer, setShowContainer] = useState(false);
  const { uploadList, uploadedList } = useSelector(
    (state: any) => state.attachment,
  );
  const [showModalExit, setShowModalExit] = useState(false);

  const dispatch = useDispatch();
  const { addToast } = useToast();

  useEffect(() => {
    if (uploadList.length) {
      uploadList.forEach((element: IUpload) => {
        if (!element.finished) {
          setShowContainer(true);
          setShow(true);
        }
      });
    }

    if (!uploadList.length) {
      setShowContainer(false);
      setShow(false);
    }
  }, [uploadList.length]);

  useEffect(() => {
    if (uploadList.length && uploadedList.length) {
      if (uploadList.length === uploadedList.length) {
        setShow(false);
        setShowContainer(false);
        dispatch(cleanUpload());
        addToast({
          type: "success",
          title: "Uploads",
          description: "Todos os uploads foram finalizados.",
        });
      }
    }
  }, [uploadedList.length, uploadList.length]);

  useEffect(() => {
    let show = false;
    const onMouseOut = (e: any) => {
      if (
        showContainer &&
        !show &&
        !showModalExit &&
        e.clientY <= 0 &&
        !e.relatedTarget
      ) {
        setShowModalExit(true);
        show = true;
      }
    };
    document.addEventListener("mouseout", onMouseOut);
    return () => document.removeEventListener("mouseout", onMouseOut);
  }, [showContainer]);

  return showContainer ? (
    <Container>
      <HeaderContainer onClick={() => setShow(!show)}>
        <HeaderTitle>Enviando arquivos</HeaderTitle>
        <IconsContainer>
          <img src={show ? ArrowDown : ArrowUp} alt="" className="icon-arrow" />
          <img
            src={close}
            alt=""
            onClick={() => setShowContainer(false)}
            className="icon-close"
          />
        </IconsContainer>
      </HeaderContainer>

      <Content show={show}>
        {uploadList.map((element: IUpload) => (
          <UploadFileItem item={element} isMain={element.isMainRecord} />
        ))}
      </Content>
      <ModalDefault
        openModal={showModalExit}
        setOpenModal={() => setShowModalExit(false)}
        title={"Upload de anexo em andamento"}
        bodyMessageTitle={"Você deseja sair da página?"}
        bodyMessageSubTitle={
          "Isso pode interromper o envio dos arquivos e gerar falhas. Tem certeza?"
        }
        textConfirm={"OK"}
        onClickConfirm={() => setShowModalExit(false)}
        textCancel={"CANCELAR"}
        onClickCancel={() => setShowModalExit(false)}
      />
    </Container>
  ) : null;
};

export default ContainerGlobalDownload;
